export default __webpack_public_path__ + "static/media/CYPRUS_REPUBLIC_EG.453452cf.jpg";